(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[956],{

/***/ 1894:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility",
      function () {
        return __webpack_require__(9370);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_P": function() { return /* binding */ AnimeContainer; },
/* harmony export */   "_o": function() { return /* binding */ AnimeContainerFacility; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8377);
/* harmony import */ var _commons_image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4532);





var ORIGSPEEDX = 10;
var ORIGSPEEDY = 10;
var Anime = function(param) {
    var parentId = param.parentId, children = param.children, svgSize = param.svgSize, _originX = param.originX, originX = _originX === void 0 ? 50 : _originX, _originY = param.originY, originY = _originY === void 0 ? 50 : _originY;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), x = ref[0], setX = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(ORIGSPEEDX), speedX = ref1[0], setSpeedX = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), y = ref2[0], setY = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(ORIGSPEEDY), speedY = ref3[0], setSpeedY = ref3[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
            animate: {
                x: x,
                y: y
            },
            transition: {
                ease: "linear",
                duration: 2.5
            },
            onAnimationComplete: function() {
                var elem = document.getElementById(parentId);
                if (elem) {
                    setX(Math.random() * originX);
                    setY(Math.random() * originY);
                }
            },
            children: children
        })
    });
};
var AnimeContainer = function(param) {
    var mode = param.mode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:left-[0] md:top-[5rem] lg:left-[5rem] lg:top-[5rem] z-0 md:block hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anime, {
                    parentId: mode === "desktop" ? "anime" : "anime-s2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-white rounded-full shadow-lv4 p-4.5 text-secondary-500 ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .BuildingBoldIcon */ .Mn, {
                            size: "34"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:left-[10rem] md:top-[13rem] z-0 md:block hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-success-500 rounded-full w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:left-[-1rem] md:top-[22rem] lg:left-[3rem] lg:top-[16rem] xl:left-[12rem] xl:top-[16rem] md:z-0 z-10 left-[1.938rem] top-[4rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anime, {
                    parentId: mode === "desktop" ? "anime" : "anime-s2",
                    originX: 20,
                    originY: 20,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-white rounded-full shadow-lv4 p-3.5 md:p-6 text-success-500 ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .TickCircle */ .bh, {
                            size: mode === "desktop" ? "48" : "24"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:left-[0] md:top-3/4 lg:left-[5rem] xl:left-[11rem] lg:top-2/3 md:z-0 z-10 left-[5.188rem] top-[10rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anime, {
                    parentId: mode === "desktop" ? "anime" : "anime-s2",
                    originX: mode === "desktop" ? 50 : 30,
                    originY: mode === "desktop" ? 50 : 30,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-white rounded-full shadow-lv4 p-3 md:p-4 text-warning-500",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .MapIcon */ .Zl, {
                            size: mode === "desktop" ? "28" : "18"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:left-[25rem] md:bottom-[6rem] z-0 md:block hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-success-500 rounded-full w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:right-[6rem] md:top-[3rem] xl:right-[6rem] xl:top-[7rem] z-0 md:block hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anime, {
                    parentId: mode === "desktop" ? "anime" : "anime-s2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-white rounded-full shadow-lv4 p-4 text-purple-500",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .LocationBoldIcon */ .Oi, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:right-[12rem] md:top-[15rem] md:z-0 z-10 left-[11.25rem] top-[4rem] md:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-purple-500 rounded-full w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:right-[12rem] md:top-[15rem] z-0 md:block hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-primary-500 rounded-full w-5 h-5"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:right-[1rem] md:top-[10rem] lg:right-[6rem] lg:top-[13rem] xl:right-[13rem] xl:top-[18rem] md:z-0 z-10 right-[1.938rem] top-[3rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anime, {
                    parentId: mode === "desktop" ? "anime" : "anime-s2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-white rounded-full shadow-lv4 p-2 md:p-6 text-danger-500",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .CalendarBulkIcon */ .J0, {
                            size: mode === "desktop" ? "48" : "20"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:right-[2rem] md:top-2/3 lg:right-[5rem] lg:top-1/2 md:z-0 z-10 right-[5.188rem] top-[9rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anime, {
                    parentId: mode === "desktop" ? "anime" : "anime-s2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-white rounded-full shadow-lv4 p-2 md:p-5 text-primary-500",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .ProfileBulkIcon */ .TT, {
                            size: mode === "desktop" ? "34" : "14"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute md:right-1/4 md:bottom-[5rem] z-0 md:block hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-warning-500 rounded-full w-5 h-5"
                })
            })
        ]
    });
};
var AnimeContainerFacility = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-[10rem] top-[16rem] z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-info-500 rounded-full w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-[-1rem] top-[26rem] lg:left-[1rem] lg:top-[25rem] xl:left-[6rem] xl:top-[18rem] z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-purple-500 w-[7.875rem] h-[7.875rem] rounded-[0.875rem]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-[0rem] top-[27rem] lg:left-[2rem] lg:top-[26rem] xl:left-[7rem] xl:top-[19.5rem] z-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anime, {
                    parentId: "anime",
                    originX: 20,
                    originY: 20,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white shadow-lv5 w-[11.75rem] p-3 rounded-[0.875rem] flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                src: "/images/popover/img-1.png",
                                alt: "Popover 1",
                                className: "w-full h-auto "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-small-normal font-medium text-neutral-900 mt-2",
                                children: "Central Valley Self Mini Storage Electronic..."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-tiny-normal text-neutral-600 mt-1",
                                children: "Fresno, CA, 1441 N Clovis Ave, 93727"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col space-y-1.5 mt-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-row justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-row space-x-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .RecordCircleIcon */ .bm, {
                                                        size: "12",
                                                        className: "text-primary-500"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-neutral-900 text-[0.625rem] leading-3",
                                                        children: "Upcoming Auctions"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-neutral-700 text-[0.625rem] leading-3",
                                                children: "100x"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-row justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-row space-x-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .RecordCircleIcon */ .bm, {
                                                        size: "12",
                                                        className: "text-neutral-900"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-neutral-900 text-[0.625rem] leading-3",
                                                        children: "Ended Auctions"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-neutral-700 text-[0.625rem] leading-3",
                                                children: "90x"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-1/4 bottom-[5rem] z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-success-500 rounded-full w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-[2rem] top-[1rem] lg:right-[5rem] lg:top-[3.5rem] xl:right-[12rem] xl:top-[3.5rem] z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anime, {
                    parentId: "anime",
                    originX: 20,
                    originY: 20,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[7.75rem] h-[7.75rem] rounded-full relative bg-[url('/images/popover/map.png')] bg-center bg-no-repeat",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute left-0 top-0 text-danger-500",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .LocationBoldIcon */ .Oi, {
                                size: "34"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-[6.5rem] top-[17rem] z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-primary-500 w-5 h-5 rounded-full"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-[3rem] bottom-[8rem] xl:right-[3rem] xl:bottom-1/4 z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-warning-500 w-[7.875rem] h-[7.875rem] rounded-full"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-[18rem] bottom-[5rem] z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-warning-500 w-5 h-5 rounded-full"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-[5rem] top-[26rem] xl:right-[5rem] xl:top-1/2 z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Anime, {
                    parentId: "anime",
                    originX: 20,
                    originY: 20,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "bg-white shadow-lv3 w-[9.875rem] p-3 rounded-xl flex flex-row justify-between items-center space-x-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-regular-none text-neutral-500",
                                    children: "Auction Type"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-neutral-900",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .ArrowDownBoldIcon */ .T9, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-2 bg-white shadow-lv5 w-[9.875rem] p-3.5 rounded-xl flex flex-col space-y-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row items-center justify-between space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-small-normal text-green-500",
                                            children: "Online"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-green-500",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .TickCircle */ .bh, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-small-normal text-neutral-500",
                                    children: "In Person"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Anime)));


/***/ }),

/***/ 9370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6200);
/* harmony import */ var _app_component_commons_button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1201);
/* harmony import */ var _app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4532);
/* harmony import */ var _app_component_commons_meta_Meta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1817);
/* harmony import */ var _app_component_plugins_Anime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2696);
/* harmony import */ var _app_helpers_MenuList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2105);
/* harmony import */ var _app_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7213);










var Index = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), mode = ref[0], setMode = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (window.innerWidth < 768) {
            setMode("mobile");
        } else {
            setMode("desktop");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_meta_Meta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: "Find Qualified Buyers For Your Storage Unit Auctions | Storage Unit Auction List ",
                description: "Sign up for a free account on Storage Unit Auction List to list and manage your storage unit auctions. This site has over 300,000 buyers looking for auctions at storage facilities just like yours across the United States."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                footerFacility: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            id: "anime",
                            className: "min-h-[18rem] md:min-h-[43.75rem] bg-new-header bg-center bg-cover bg-no-repeat relative px-4.5 md:px-16 flex flex-col items-center justify-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute left-0 w-full h-full md:block hidden z-0",
                                    style: {
                                        background: "linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute left-0 w-full h-full z-0 hidden",
                                    style: {
                                        background: "linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative z-10 flex flex-col items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "max-w-[21.188rem] md:max-w-[40.375rem] text-title3 leading-[2.125rem] md:text-[2.5rem] md:leading-[3.125rem] font-bold text-neutral-900 mt-12 md:mt-0 text-center capitalize",
                                            children: [
                                                "Promote your",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-gradient-7",
                                                    children: "storage auctions"
                                                }),
                                                " to over 300,000 buyers across the country"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-4.5 md:mt-7 max-w-[21.188rem] md:max-w-[40.375rem] text-neutral-700 text-small-normal leading-6 md:!text-lg text-center ",
                                            children: "Storage Unit Auction List is used by storage facilities across the United States to manage and promote their monthly auctions."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-4.5 md:mt-12 w-[10.438rem] md:w-[10.438rem]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: "".concat("https://app.storageunitauctionlist.com", "/f/sign-up"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        size: "lg",
                                                        className: "!rounded-full !px-3 w-full !font-medium",
                                                        onClick: function() {},
                                                        children: "Register Now"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: "anime-s2",
                                    className: "static hidden w-full h-full md:block",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_plugins_Anime__WEBPACK_IMPORTED_MODULE_7__/* .AnimeContainerFacility */ ._o, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-12 md:mt-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "md:p-0 p-2.5 flex flex-col items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-center font-bold text-neutral-900 md:text-title1 md:leading-[3.625rem] text-title3 leading-9 md:w-auto w-[19.938rem]",
                                            children: [
                                                "What is",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-gradient-7",
                                                    children: "Storage Unit Auction List?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-3 text-neutral-700 md:text-neutral-900 text-center md:text-title3 md:leading-[2.125rem] text-small-normal leading-6 md:w-auto w-[19.938rem] px-0 md:px-3 lg:px-0",
                                            children: "Use one dashboard to manage and promote all your storage facilities auctions"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-7 md:mt-[5.25rem] grid grid-cols-1 md:grid-cols-2 md:gap-x-[2.125rem] gap-y-3 md:gap-y-0",
                                    children: [
                                        mode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                            animateIn: "animate__fadeIn",
                                            animateOnce: true,
                                            className: "min-h-[19rem] md:min-h-[27.125rem] relative",
                                            initiallyVisible: mode === "mobile" ? true : false,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute w-full h-[18.75rem] gradient-third rounded-r-[2.125rem] z-0 before:absolute before:w-[40vw] before:h-full before:left-[-40vw] before:gradient-third"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "relative pl-[0] pt-[1.375rem] pb-[0] md:pt-[0]",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            src: "/images/step/fac-step-1-main.png",
                                                            alt: "Step 1",
                                                            className: "absolute w-full h-auto "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            src: "/images/step/fac-step-1-second.png",
                                                            alt: "Step 1",
                                                            className: "absolute w-[15rem] lg:w-[20rem] xl:w-2/3 h-auto right-5 top-20 md:right-[2rem] md:top-[4rem] lg:right-[2rem] lg:top-[5rem] xl:right-[2rem] xl:top-[5.8rem]"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                            animateIn: "animate__slideInUp",
                                            animateOnce: true,
                                            className: "flex flex-col justify-center items-start space-y-4.5 max-w-[38rem] px-4.5 md:px-0 md:pr-3 lg:px-0 mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "font-bold text-neutral-900 md:text-4xl md:leading-[2.723rem] text-large-normal md:capitalize",
                                                    children: "A platform that storage unit buyers use to search for storage unit auctions"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-neutral-700 md:text-neutral-900 md:text-title3 md:leading-9 text-small-normal leading-6",
                                                    children: "Hundreds of thousands of storage unit buyers have signed up to use Storage Unit Auction list to find storage unit auctions happening around them."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-7 md:mt-[10rem] grid grid-cols-1 md:grid-cols-2 md:gap-x-[2.125rem] gap-y-3 md:gap-y-0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                            animateIn: "animate__fadeIn",
                                            animateOnce: true,
                                            className: "md:hidden relative min-h-[19rem]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute w-full h-[18.75rem] gradient-third rounded-l-[2.125rem] z-0 before:absolute before:md:w-[40vw] before:h-full before:right-[-40vw] before:gradient-third"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "relative pr-4.5 pt-4.5 pb-[0] px-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            src: "/images/step/fac-step-2-main.png",
                                                            alt: "Step 2",
                                                            className: "absolute w-full h-auto "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            src: "/images/step/fac-step-2-second.png",
                                                            alt: "Step 2",
                                                            className: "absolute w-[15rem] h-auto right-[4rem] top-[5rem]"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                            animateIn: "animate__slideInUp",
                                            animateOnce: true,
                                            className: "w-full flex flex-row items-center justify-end lg:px-0 md:px-0 md:pl-3 px-4.5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col justify-center md:items-end space-y-3 md:space-y-4.5 max-w-[39rem]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "font-bold text-neutral-900 md:text-4xl md:leading-[2.723rem] text-large-normal md:capitalize md:text-right",
                                                        children: "Enable your Storage Facility to easily promote upcoming auctions"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-neutral-700 md:text-neutral-900 md:text-title3 md:leading-9 text-small-normal leading-6 md:text-right",
                                                        children: "Storage Unit Auction List provides an easy way for you to publish your upcoming storage unit auctions. Your auctions will be synced with our database, and buyers interested in storage units will be able to see your auctions."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                            animateIn: "animate__fadeIn",
                                            animateOnce: true,
                                            className: "min-h-[27.125rem] md:block hidden relative",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute w-full h-[18.75rem] gradient-third rounded-l-[2.125rem] z-0 before:absolute before:w-[40vw] before:h-full before:right-[-40vw] before:gradient-third"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "relative pt-[0] pl-[0] pr-[0] ",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            src: "/images/step/fac-step-2-main.png",
                                                            alt: "Step 2",
                                                            className: "absolute w-full h-auto "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            src: "/images/step/fac-step-2-second.png",
                                                            alt: "Step 2",
                                                            className: "absolute w-[16rem] lg:w-[22rem] xl:w-2/3 h-auto xl:right-[5rem] xl:top-[6.5rem] lg:right-[3rem] lg:top-[4rem] right-[2rem] top-[3rem]"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                            className: "mt-12 md:mt-[7.75rem] mx-auto lg:w-[60rem] xl:w-[68.125rem] gradient-main md:rounded-[4rem] md:p-16 px-4.5 md:px-4 lg:px-4.5 md:py-6 py-4.5",
                            animateIn: "animate__fadeIn",
                            animateOnce: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                    animateIn: "animate__fadeIn",
                                    animateOnce: true,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-center text-title3 leading-[2.125rem] md:text-title1 md:leading-[3.625rem] font-bold text-neutral-900 lg:px-12",
                                            children: [
                                                "The Leading",
                                                " ",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                                    className: "sm:hidden"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-gradient-7",
                                                    children: "Storage Unit Auction"
                                                }),
                                                " ",
                                                "Search Engine"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex justify-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-center text-small-tight leading-6 md:text-title3 md:leading-[2.125rem] md:text-neutral-900 mt-3 font-normal md:w-full w-[21.188rem] text-neutral-700",
                                                children: "List your storage facility on the most trusted storage auction website in the United States."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "lg:px-10 grid grid-cols-1 md:grid-cols-2 md:gap-x-5 gap-y-5 md:gap-y-12 mt-12",
                                    children: _app_helpers_MenuList__WEBPACK_IMPORTED_MODULE_8__/* .advgListFacility.map */ .V0.map(function(e, key) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                            className: "flex flex-col items-center p-6 bg-white rounded-3xl shadow-lv4",
                                            animateIn: "animate__fadeIn",
                                            animateOnce: true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                                    animateIn: "animate__zoomIn",
                                                    animateOnce: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        src: e.icon,
                                                        alt: e.title,
                                                        className: "w-[5.875rem] h-[5.875rem]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                                    animateIn: "animate__slideInUp",
                                                    animateOnce: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-large-normal md:text-title3 font-bold text-neutral-900 mt-3 text-center md:capitalize",
                                                            children: e.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-large-normal md:text-title3 font-bold text-neutral-900 text-center md:capitalize",
                                                            children: e.subtitle
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-neutral-900 text-regular-tight mt-3 text-center md:w-auto",
                                                            children: e.desc
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                            animateIn: "animate__fadeIn",
                            className: "mt-12 md:mt-[5rem] xl:mt-[7.75rem] md:mx-0 xl:mx-[5.5rem] md:w-auto px-4.5 lg:px-[5.438rem] pt-9 md:pt-[4.25rem]",
                            animateOnce: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                animateIn: "animate__slideInUp",
                                animateOnce: true,
                                className: "relative rounded-t-[2.125rem] md:rounded-t-[4rem] py-6 px-3 md:py-16 md:px-8 gradient-main flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                        animateIn: "animate__slideInRight",
                                        className: "absolute lg:right-[-4.5rem] lg:top-[-4rem] top-[-2.5rem] right-[-1rem]",
                                        animateOnce: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                            animateIn: "animate__fadeIn",
                                            animateOnce: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/images/box.svg",
                                                alt: "Box",
                                                className: "lg:w-[10.5rem] lg:h-[10.5rem] w-[60px] h-[60px]"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                        animateIn: "animate__slideInLeft",
                                        className: "absolute lg:left-[-5rem] lg:bottom-[3rem] left-[-1.5rem] bottom-0",
                                        animateOnce: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                            animateIn: "animate__fadeIn",
                                            animateOnce: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_image_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/images/bid.svg",
                                                alt: "Box",
                                                className: "lg:w-[10.5rem] lg:h-[10.5rem] w-[60px] h-[60px]"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                        animateIn: "animate__slideInUp",
                                        className: "text-title3 leading-9 md:text-[3rem] md:leading-[4.5rem] font-bold text-neutral-900 text-center",
                                        animateOnce: true,
                                        children: [
                                            "Ready To Promote Your ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                                className: "hidden sm:inline"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-gradient-7",
                                                children: "Storage Unit Auctions?"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                        className: "mt-3.5 md:mt-12 text-neutral-700 md:text-title3 md:leading-[3rem] text-small-normal leading-6 text-center md:font-light",
                                        animateIn: "animate__slideInUp",
                                        animateOnce: true,
                                        children: [
                                            "Put your storage unit auctions in front of 300,000 registered \xa0",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                                className: "hidden lg:inline"
                                            }),
                                            "buyers across the country."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animation_on_scroll__WEBPACK_IMPORTED_MODULE_3__/* .AnimationOnScroll */ .n, {
                                        className: "mt-[2.375rem] md:mt-12 ",
                                        animateIn: "animate__slideInUp",
                                        animateOnce: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "".concat("https://app.storageunitauctionlist.com", "/f/sign-up"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    size: "lg",
                                                    className: "!rounded-full !px-3",
                                                    onClick: function() {},
                                                    children: "Add Your Storage Facility"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [939,731,659,774,888,179], function() { return __webpack_exec__(1894); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);